import { render, staticRenderFns } from "./aRoomDetailHisOwner.vue?vue&type=template&id=77e18e6d&scoped=true"
import script from "./aRoomDetailHisOwner.vue?vue&type=script&lang=js"
export * from "./aRoomDetailHisOwner.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailHisOwner.vue?vue&type=style&index=0&id=77e18e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e18e6d",
  null
  
)

export default component.exports